import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { withWizard } from '@cimpress-technology/ff-react-components/lib/Wizard';
import StepTitle from '../../../common/StepTitle';
import WizardNavigator from '../../../common/WizardNavigator';
import { css } from 'react-emotion';
import { SkuSelector } from '@cimpress-technology/ff-react-components';
import omit from 'lodash/omit';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { auth } from '../../../../utils/auth';
import Button from '../../../common/Button';
import { typeIsFulfiller } from '../../../../reducers/identities/utils';

const sectionsStyle = css({
  padding: '0 20px'
});

class AddProductsStep extends PureComponent {
  static defaultProps = {};

  state = {};

  componentDidUpdate(prevProps, prevState) {
    // if the selection of skus have changed,
    // (ie. user decided to go back and change the skus they would like to create the term with)
    // then clear the previous productPricingTerm state
    const { flow, onChange } = this.props;
    if (!isEqual(prevProps.flow.selectedSkus, flow.selectedSkus)) {
      onChange({ productPricingTerm: {}, shippingPricingTerm: {} });
    }
  }

  onPrev = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.previous);
  };

  onNext = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.next);
  };

  onAddSku = skuInfo => {
    const { onChange, flow } = this.props;
    onChange({ selectedSkus: { ...flow.selectedSkus, [skuInfo.sku]: skuInfo } });
  };

  onBulkAddSkus = skusToAdd => {
    const { onChange, flow } = this.props;
    onChange({ selectedSkus: { ...flow.selectedSkus, ...skusToAdd } });
  };

  onBulkRemoveSkus = skusToRemove => {
    const { onChange, flow } = this.props;
    const newSkus = omit(flow.selectedSkus, skusToRemove);
    onChange({ selectedSkus: newSkus });
  };

  onRemoveSku = skuInfo => {
    const { flow, onChange } = this.props;
    onChange({ selectedSkus: omit(flow.selectedSkus, skuInfo.sku) });
  };

  render() {
    const {
      t,
      i18n,
      flow: { initiator }
    } = this.props;
    return (
      <div>
        <StepTitle icon="t-shirt-l" title={t('createContract:addProducts.header')} />
        <div className={sectionsStyle}>
          <SkuSelector
            addNonExistentSkus
            locale={i18n.language}
            skuSearchSectionTitle={t('createContract:addProducts.searchAndAddProducts')}
            skuBinSectionTitle={t('createContract:addProducts.selectedProducts')}
            sellerFulfillerId={initiator && typeIsFulfiller(initiator.type) ? initiator.id : null}
            selectedSkus={this.props.flow.selectedSkus}
            onAddSku={this.onAddSku}
            onRemoveSku={this.onRemoveSku}
            onBulkAddSkus={this.onBulkAddSkus}
            onBulkRemoveSkus={this.onBulkRemoveSkus}
            // we need this props in order to allow bulk removals
            unremoveableSkuList={[]}
            onGetAccessToken={auth.getAccessToken}
            marketable={false}
            skipLoadDescriptionsForBulkAddSkus={true}
          />
        </div>
        <WizardNavigator
          onPrev={this.onPrev}
          onNext={this.onNext}
          customNext={
            <Button
              className="btn btn-primary"
              disabled={isEmpty(this.props.flow.selectedSkus)}
              disabledTooltipContents={t('createContract:addProducts.mustSelectProductsMessage')}
              onClick={this.onNext}>
              {t('common:commonWords.next')}
            </Button>
          }
        />
      </div>
    );
  }
}

export default withWizard(withTranslation()(AddProductsStep));
